// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox","498": "geo-vendor",}[chunkId] || chunkId) + "." + {"182": "7a473029e0f0eabd","396": "781d69df0a6059aa","460": "714125ef78ee045e","498": "7636d16cb86a709d","917": "f7230ee5526c4742","985": "ba1477e93750f82a",}[chunkId] + ".chunk.js"
}